import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext, useRef } from 'react';
import SectionsSelect from './SectionsSelect'
import SectionForm from './SectionForm'
import {FormProvider} from '@thinkwell/react.common'
import {EditModal} from '@thinkwell/react.polaris'
import { SectionsContext } from './contexts/yolk/Sections'
import { HostContext } from './contexts/Host'

export default function EditTransfer(props) {
  const host = useContext(HostContext)
  const [sections, fetchSections] = useContext(SectionsContext)

  const onActive = async(active, form) => {
    if(active && !props.sections && props.forAccount) {
      const fetchSectionsUrlPath = `enrollments/${props.id}/sections/transfer.json`
      const fetchSectionsUrl = `${host}/accounts/${fetchSectionsUrlPath}?shop_name=${props.shop_name}`
      const sections = await fetchSections(fetchSectionsUrl)
      const sectionId = form.field('section_id')
      const section = sectionId && (sections || []).find((section) => sectionId == (section.id || section.section_id))
      if ((sections || []).length && !section) {
        const firstSectionId = sections[0].id || sections[0].section_id
        console.log(`select first section ${firstSectionId} ${sectionId ? `(from ${sectionId})` : ''}`)
        flushSync(() => {
          form.onData('section_id')(firstSectionId)
        })
      }
    }
    props.onActive && props.onActive(active)
  }

  const url = (form) => {
    const urlPath = props.url || `enrollments/${props.id}/sections/${form.field('section_id')}/transfer.json`
    return props.forAccount ? `${host}/accounts/${urlPath}?shop_name=${props.shop_name}&shop=${props.shop_name}&cid=${props.cid}` : `/admin/${urlPath}`
  }

  const data = {
    organization_id: props.organization_id,
    section_id: props.section_id
  }

  return (<FormProvider data={data} omit={['organization_id']}><EditModal
      active={props.active}
      onActive={onActive}
      onSave={props.onSave}
      onSaving={props.onSaving}
      url={url}
      linkText={props.linkText}
      saveText="Transfer"
      title="Transfer to Section"
    >
    { props.forAccount ?
      <SectionsSelect required
        notFoundMessage="There are no classes available for registration."
      /> :
      <SectionForm required={true}
        sectionsNotFoundMessage="There are no classes available for transfer."
      />
    }
  </EditModal></FormProvider>);
}
